import { EMPTY_ARRAY, EMPTY_OBJECT } from "@multiweb/reactUtils";
import { FetchingState } from "@multiweb/types/react";
import { IDataSourceState } from "./types";

/**
 * Iniciální stav DataSource reduceru.
 */
export const DATA_SOURCE_INIT_STATE: IDataSourceState = {
    data: {
        records: EMPTY_OBJECT,
        recordsIds: EMPTY_ARRAY,
    },
    multiselect: {
        selectedRecords: EMPTY_OBJECT,
        checkedRecords: EMPTY_OBJECT,
        lastSelectedRecordId: "",
        multiselectMode: false,
        isCheckedAll: false,
        keepCheckedIncomingData: false,
        rootNodes: EMPTY_OBJECT,
    },
    loading: {
        fetchingState: FetchingState.initialized,
        startIndex: 0,
        fetchingCount: 0,
        hasNextItems: true,
        disabledLoading: false,
    },
    actions: {
        actions: EMPTY_OBJECT,
        recordActionsIds: EMPTY_ARRAY,
        hasDetailForm: false,
    },
    workflowActions: {
        actions: EMPTY_OBJECT,
        actionsOrder: EMPTY_ARRAY,
        fetchingState: FetchingState.initialized,
    },
    config: {
        objectName: "",
        attributes: EMPTY_OBJECT,
        attributeNames: EMPTY_ARRAY,
        fullLengthAttributes: EMPTY_ARRAY,
        recordIdKey: "id",
        formContext: EMPTY_OBJECT,
        hasWorkflow: false,
        isPersistent: true,
        customDataSourceId: "",
        customMethodsData: EMPTY_OBJECT,
    },
    conditions: {
        condition: "",
        fulltextCondition: EMPTY_OBJECT,
        masterFrameCondition: "",
        conditionParams: EMPTY_ARRAY,
    },
    attributeInfo: EMPTY_OBJECT,
    orderBy: EMPTY_ARRAY,
};
